/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseGetNoticeResponse
 */
export interface ResponseGetNoticeResponse {
    /**
     * 
     * @type {number}
     * @memberof ResponseGetNoticeResponse
     */
    baseId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetNoticeResponse
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetNoticeResponse
     */
    displayAt?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetNoticeResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetNoticeResponse
     */
    tenantId?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetNoticeResponse
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetNoticeResponse
     */
    userId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseGetNoticeResponse
     */
    visible?: boolean;
}

/**
 * Check if a given object implements the ResponseGetNoticeResponse interface.
 */
export function instanceOfResponseGetNoticeResponse(value: object): value is ResponseGetNoticeResponse {
    return true;
}

export function ResponseGetNoticeResponseFromJSON(json: any): ResponseGetNoticeResponse {
    return ResponseGetNoticeResponseFromJSONTyped(json, false);
}

export function ResponseGetNoticeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetNoticeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'content': json['content'] == null ? undefined : json['content'],
        'displayAt': json['display_at'] == null ? undefined : json['display_at'],
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'title': json['title'] == null ? undefined : json['title'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'visible': json['visible'] == null ? undefined : json['visible'],
    };
}

export function ResponseGetNoticeResponseToJSON(json: any): ResponseGetNoticeResponse {
    return ResponseGetNoticeResponseToJSONTyped(json, false);
}

export function ResponseGetNoticeResponseToJSONTyped(value?: ResponseGetNoticeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'content': value['content'],
        'display_at': value['displayAt'],
        'id': value['id'],
        'tenant_id': value['tenantId'],
        'title': value['title'],
        'user_id': value['userId'],
        'visible': value['visible'],
    };
}

